const socketModule = {
    namespaced: true,
    state: {
      connected: false,
      nspConnected: false,
      socketMessages: [],
      socketWeight: 0,
      selectedScale: null,
    },
    getters:{
        selectedScale: state => {
          return state.selectedScale
        },
    },
    mutations: {
        socketOnConnect (state) {
            state.socketMessages.push('socket connected');
            state.connected = true;
        },
        socketOnDisconnect (state) {
            state.socketMessages.push('socket disconnected');
            state.connected = false;
            state.socketWeight = 0;
        },
        namespaceSocketOnConnect (state) {
            state.socketMessages.push('namespace/socket connected');
            state.nspConnected = true;
        },
        namespaceSocketOnDisconnect (state) {
            state.socketMessages.push('namespace/socket disconnected');
            state.nspConnected = false;
        },
        pushMessageToSocketMessages (state, message) {
            if (message.numberScale === state.selectedScale) {
                state.socketWeight = message.weight;
            }
        },
        updateSelectedScale (state, payload) {
            state.selectedScale = payload;
        }

    },
    actions: {
        updateSelectedScale: ({ commit }, payload) => {
          commit('updateSelectedScale', payload);
        } ,

        socketConnect: () => {},
        socketDisconnect: () => {},
        socketEmitSendMessage: ({ commit }, message) => {
            commit('pushMessageToSocketMessages', message);
        },
        namespaceSocketConnect: () => {},
        namespaceSocketDisconnect: () => {},
        namespaceSocketEmitSendMessage: ({ commit }, message) => {
            commit('pushMessageToSocketMessages', 'emit to namespace/SEND_MESSAGE: ' + message);
        }
    }
};

export default socketModule;
